import React from 'react';

//import Scss
import './assets/scss/themes.scss';

//imoprt Route
import Route from './Routes';

import ErrorBoundary from './Components/Common/ErrorBoundary';

function App() {
  return (
    <ErrorBoundary>
      <React.Fragment>
        <Route />
      </React.Fragment>
    </ErrorBoundary>
  );
}

export default App;
